import React from "react";
import Navbar1 from "../navbar/Navbar1";
import { FaChevronDown } from "react-icons/fa";

import {
  FaFacebook,
  FaLinkedin,
  FaYoutube,
  FaPhoneAlt,
  FaArrowAltCircleRight,
} from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const AboutHeader = () => {
  return (
    <div id="header">
      <div
        className="pt-4"
        style={{
          background:
            'url("/assests/Homepageheader.png") no-repeat center center/cover',
        }}
      >
        <div className="d-flex justify-content-between px-md-5 mx-6">
          <div className="d-flex gap-4 ">
            <a href="https://www.facebook.com/kibisports" target="_blank">
              <FaFacebook color="white" size={22} />
            </a>
            <a
              href="https://in.linkedin.com/company/kibi-sports"
              target="_blank"
            >
              <FaLinkedin color="white" size={22} />
            </a>
            <a href="https://www.youtube.com/c/KIBISPORTS" target="_blank">
              <FaYoutube color="white" size={22} />
            </a>
          </div>
          <div className="text-white">
            <ul className="d-md-flex gap-3">
              <li className="d-flex gap-2">
                <FaPhoneAlt color="white" size={20} />
                <p>+91 1234567890</p>
              </li>
              <li className="d-flex gap-2">
                <MdEmail color="white" size={20} />
                <p>testing@gmail.com</p>
              </li>
            </ul>
          </div>
        </div>
        <Navbar1 />

        <div className="py-5">
          <h1 className="text-white headerText text-center">
            <span className="fw-bold">ABOUT US</span>
            
          </h1>
          <p className="mt-4 text-white normalText text-center">
           Lorem Ipsum is simply dummy text of the printing and typesetting industry
          </p>
          
        </div>
      </div>
    </div>
  );
};

export default AboutHeader;
